import React from 'react';
import { styled } from '@mui/material/styles';
import { Container, Typography, Link } from '@mui/material';

const PREFIX = 'Footer';

const classes = {
    root: `${PREFIX}-root`,
    caption1: `${PREFIX}-caption1`,
    caption: `${PREFIX}-caption`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        backgroundColor: 'rgb(250, 250, 250)',
        color: '#fff',
        padding: '30px 0px',
        fontFamily: 'Roboto',
    },

    [`& .${classes.caption1}`]: {
        fontWeight: '800',
        color: 'rgb(110, 110, 110)',
        padding: '0px 16px',
        float: 'left',
        display: 'inline-block'
    },

    [`& .${classes.caption}`]: {
        fontWeight: '800',
        color: 'rgb(110, 110, 110)',
        padding: '0px 16px',
        float: 'right',
        display: 'inline-block'
    }
}));

const Footer = () => {


    return (
        <Root className={classes.root}>
            <Container maxWidth="lg">
                        <Typography variant="caption" gutterBottom className={classes.caption1} component={Link} href="https://arconnect.arco1.com/spaces/166/ami-innovation-team/home">
                            ARCO/Murray Innovation
                        </Typography>
                        <Typography variant="caption" gutterBottom className={classes.caption} component={Link} href="mailto:innovation@arcomurray.com">
                            innovation@arcomurray.com
                        </Typography>                    
            </Container>
        </Root>
    );
};

export default Footer;
